import type { FunctionComponent } from 'react';
import { Button } from '@fff-web/fff-ui-shared';
import ButtonAction from '../../interfaces/buttonAction';
import * as styles from './NavigationFooter.module.css';

type OwnProps = {
  backButton?: ButtonAction;
  nextButton: ButtonAction;
};

const NavigationFooter: FunctionComponent<OwnProps> = ({ backButton, nextButton }) => {
  const backButtonComponent = backButton ? (
    <div className={styles.backButton}>
      <Button
        onClick={backButton ? backButton.onClick : () => null}
        disabled={nextButton.disabled}
        variation="black-outline"
      >
        {backButton?.label}
      </Button>
    </div>
  ) : null;

  const buttonClass = `${styles.nextButton}${!backButtonComponent ? ` ${styles.oneButton}` : ''}`;

  return (
    <div className={styles.navigationFooterContainer} data-testid="navigation-footer">
      {backButtonComponent}
      <div className={buttonClass}>
        <Button onClick={nextButton.onClick} disabled={nextButton.disabled}>
          {nextButton.label}
        </Button>
      </div>
    </div>
  );
};

export default NavigationFooter;
